import { useState } from 'react';

export const useExpandableList = (initialExpanded = false) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  const toggle = () => setExpanded(!expanded);
  const collapse = () => setExpanded(false);
  const expand = () => setExpanded(true);

  return {
    expanded,
    toggle,
    collapse,
    expand
  };
};